import { Modal } from '@mantine/core';
import { ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import Button from '../Button/Button';

interface ConfirmActionModalProps {
    opened: boolean;
    onClose: () => void;
    title: string;
    message: ReactNode;
    confirmLabel: string;
    confirmVariant?: 'primary' | 'danger';
    isLoading?: boolean;
    onConfirm: () => void;
}

export default function ConfirmActionModal({
    opened,
    onClose,
    title,
    message,
    confirmLabel,
    confirmVariant = 'primary',
    isLoading,
    onConfirm,
}: ConfirmActionModalProps) {
    const { t } = useTranslation('common');
    return (
        <Modal
            size="sm"
            opened={opened}
            onClose={onClose}
            withCloseButton={false}
            title={<span className="text-base font-bold">{title}</span>}
            overlayProps={{
                backgroundOpacity: 0.55,
                blur: 3,
            }}
            transitionProps={{ transition: 'fade', duration: 128, timingFunction: 'linear' }}
            centered
        >
            <div className="flex flex-col justify-start items-start gap-4">
                <div className="text-sm text-fg/68">{message}</div>
                <div className="w-full flex flex-col justify-start items-start gap-2.5">
                    <Button
                        width="100%"
                        variant={confirmVariant === 'danger' ? 'danger' : 'primary'}
                        onClick={onConfirm}
                        isLoading={isLoading}
                    >
                        {confirmLabel}
                    </Button>
                    <Button
                        width="100%"
                        variant="secondary"
                        onClick={onClose}
                        disabled={isLoading}
                        data-autofocus={confirmVariant === 'danger' || undefined}
                    >
                        {t('actions.cancel')}
                    </Button>
                </div>
            </div>
        </Modal>
    );
}
